import type { IAnalyticsRepository } from '@src/domain/analytics/repository/analytics_repository';
import { AnalyticsConfig } from '@src/domain/analytics/entities/analytics_config.entity';

/**
 * Initialize Analytics Use Case
 * Handles initialization of the analytics system
 */
export class InitializeAnalyticsUseCase {
    constructor(private readonly analyticsRepository: IAnalyticsRepository) { }

    async execute(params: {
        measurementId: string;
        enabled?: boolean;
        debug?: boolean;
        testMode?: boolean;
        options?: {
            cookieFlags?: string;
            cookieDomain?: string;
            cookieExpires?: number;
            anonymizeIp?: boolean;
        };
    }): Promise<void> {
        const config = AnalyticsConfig.create({
            measurementId: params.measurementId,
            enabled: params.enabled,
            debug: params.debug,
            testMode: params.testMode,
            options: params.options,
        });

        await this.analyticsRepository.initialize(config);
    }
}
